import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getProducts } from '../../services/api';
import ProductCard from '../../components/ProductCard/ProductCard';
import {FaSearch} from 'react-icons/fa';

export default function Shop() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '');
  const [category, setCategory] = useState(searchParams.get('category') || '');
  const [sort, setSort] = useState(searchParams.get('sort') || '');

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (category) params.category = category;
    if (searchTerm) params.search = searchTerm;
    if (sort) params.sort = sort;
    getProducts(params)
      .then(data => setProducts(data))
      .finally(() => setLoading(false));
  }, [category, searchTerm, sort]);

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchParams(searchTerm ? { search: searchTerm } : {});
  };

  const handleClearFilters = () => {
    setSearchTerm('');
    setCategory('');
    setSort('');
    setSearchParams({});
  };

  const hasFilters = category || searchTerm || sort;

  return (
    <div className="min-h-screen bg-black px-4 py-24" dir="rtl">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
          <div>
            <h1 className="text-4xl font-black text-white">المتجر</h1>
            <p className="text-neutral-400 mt-1">
              {products.length} منتج متاح
            </p>
          </div>

          {hasFilters && (
            <button
              onClick={handleClearFilters}
              className="text-red-500 hover:text-red-400 text-sm font-bold transition"
            >
              مسح الفلاتر
            </button>
          )}
        </div>

        {/* Filters */}
        <div className="flex flex-wrap gap-3 mb-10">
          {/* Search */}
          <form onSubmit={handleSearch} className="flex gap-2 flex-1 min-w-[200px]">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="ابحث عن منتج..."
              className="p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white placeholder-neutral-500 w-full"
            />
            <button type="submit" className="bg-red-600 text-white px-6 py-3 font-bold rounded-lg hover:bg-red-700 transition shrink-0">
              بحث
            </button>
          </form>

          {/* Category Filter */}
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white"
          >
            <option value="">جميع الفئات</option>
            <option value="blenders">خلاطات</option>
            <option value="air-fryers">قلايات هوائية</option>
            <option value="coffee-makers">ماكينات قهوة</option>
            <option value="food-processors">محضرات شراب وطعام</option>
            <option value="kettles">غلايات</option>
            <option value="microwaves">ميكروويف</option>
            <option value="toasters">مكانس</option>
            <option value="juicers">عصارات</option>
            <option value="rice-cookers">مراوح ومكيفات</option>
            <option value="slow-cookers">مستلزمات منزلية</option>
            <option value="steamers">مكوى البخارات</option>
            <option value="other">أخرى</option>
          </select>

          {/* Sort */}
          <select
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            className="p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white"
          >
            <option value="">ترتيب افتراضي</option>
            <option value="price-low">السعر: منخفض إلى مرتفع</option>
            <option value="price-high">السعر: مرتفع إلى منخفض</option>
            <option value="newest">الأحدث</option>
            <option value="rating">الأعلى تقييماً</option>
          </select>
        </div>

        {/* Products Grid */}
        {loading ? (
          <div className="text-center py-20">
            <div className="inline-block w-10 h-10 border-4 border-neutral-700 border-t-red-500 rounded-full animate-spin"></div>
            <p className="text-neutral-400 mt-4">جار التحميل...</p>
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-20">
            <FaSearch className="text-6xl mb-4 text-neutral-500 mx-auto" />
            <p className="text-neutral-400 text-lg">لا توجد منتجات مطابقة</p>
            {hasFilters && (
              <button onClick={handleClearFilters} className="text-red-500 hover:text-red-400 mt-2 font-bold">
                مسح الفلاتر وعرض الكل
              </button>
            )}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}